import { ReactNode } from 'react'
import { connect } from 'react-redux'

import moment from 'moment'

import BasePage, { CONNECTION_ERROR } from '../BasePage'

import LoginRegister from '../../components/login/LoginRegister'

import Contractor from '../../components/people/contractor/Contractor'
import CommonsPolicyFields from '../../components/commons/CommonsPolicyFields'

import { getPrivacyForSubmit } from '../../components/privacy/BasicPrivacy'
import NoMotorPrivacy from '../../components/privacy/NoMotorPrivacy'
import ModalFinalQuestion from '../../components/final/ModalFinalQuestion'

import SinglePage from '../../components/pagination/SinglePage'
import Pagination from '../../components/pagination/Pagination'

import SiNo, { SiNoType, getBoolean, getSiNoValue } from '../../components/siNo/SiNo'

import Select from '../../libs/ui/inputs/Select'
import MultipleCheckbox from '../../libs/ui/inputs/MultipleCheckbox'

import ModalWaith from '../../libs/ui/modal/ModalWaith'
import ModalNotification from '../../libs/ui/modal/ModalNotification'

import { CompleteValidationError } from '../../libs/validation/completeValidationError'
import { getTipoTutelatiSalute, getTipoTuteleSalute, getTipoRedditoSalute, getTipoSituazioniSalute, getTipoMalattie } from '../../libs/initialization/remoteInits'
import { DATE_FORMAT } from '../../libs/validation/dateValidation'

import { HealthPageState, HealthPageProps, healtPageInitialState, healthUpdate } from './HealthPageSilce'
import * as HealthValidation from './HealthValidation'

import { ZUKO_TRAK_ID } from '../../trak/zuko'

import { store } from '../../redux/store'

import '../../sass/App.scss'



class HealthPage extends BasePage<HealthPageProps, HealthPageState> {

    constructor (props: any) {
        super(props)

        this.state = {
            ...healtPageInitialState,
            ...props
        }

        
        this.saveStateAndRedux = this.saveStateAndRedux.bind(this)

        this.updateTipo_tutelati = this.updateTipo_tutelati.bind(this)
        this.updateTipo_tutelesalute = this.updateTipo_tutelesalute.bind(this)
        this.updateTipo_reddito = this.updateTipo_reddito.bind(this)
        this.updateTipo_situazioni = this.updateTipo_situazioni.bind(this)
        this.updateTipo_malattie = this.updateTipo_malattie.bind(this)
        this.updateSoggetti = this.updateSoggetti.bind(this)
        this.updateReddito = this.updateReddito.bind(this)
        this.updateCoperture = this.updateCoperture.bind(this)
        this.updateSituazioni = this.updateSituazioni.bind(this)
        this.updatePatologie = this.updatePatologie.bind(this)

        this.updateHasSituazioni = this.updateHasSituazioni.bind(this)
        this.updateHasPatologie = this.updateHasPatologie.bind(this)

        this.step2Validation = this.step2Validation.bind(this)
        this.step3Validation = this.step3Validation.bind(this)
        this.step4Validation = this.step4Validation.bind(this)
        this.step5Validation = this.step5Validation.bind(this)
        this.getValidationError = this.getValidationError.bind(this)
        this.printError = this.printError.bind(this)
        this.getRilevanzaForSubmit = this.getRilevanzaForSubmit.bind(this)
        this.getSpecificDataForSubmit = this.getSpecificDataForSubmit.bind(this)
    }

    componentDidMount(): void {
        super.componentDidMount()
        
        const Zuko = window.Zuko

        if (Zuko && ZUKO_TRAK_ID) {
            Zuko.trackForm( {target: document.body, slug: ZUKO_TRAK_ID} ).trackEvent(Zuko.FORM_VIEW_EVENT)
        }

        if (this.state.tipo_tutelati === undefined) {
            getTipoTutelatiSalute(this.updateTipo_tutelati, this.manageExpiredSessions)
        }
        if (this.state.tipo_tutelesalute === undefined) {
            getTipoTuteleSalute(this.updateTipo_tutelesalute, this.manageExpiredSessions)
        }
        if (this.state.tipo_reddito === undefined) {
            getTipoRedditoSalute(this.updateTipo_reddito, this.manageExpiredSessions)
        }
        if (this.state.tipo_situazioni === undefined) {
            getTipoSituazioniSalute(this.updateTipo_situazioni, this.manageExpiredSessions)
        }
        if (this.state.tipo_malattie === undefined) {
            getTipoMalattie(this.updateTipo_malattie, this.manageExpiredSessions)
        }
    }

    render () : ReactNode {
        const isLogged = this.state.expiredSessionError === false ? this.state.user !== undefined : false

        const erroOccours = this.state.globalError !== undefined

        return (
            <>
                <article className='container-fluid py-5'>
                    <div className='row justify-content-center'>
                        <div className='col-12 col-md-8'>

                            <header className='row'>
                                <form id="login_register_form" autoComplete='off'>
                                    <LoginRegister 
                                        isLogged={ isLogged } 
                                        isExpire={ this.state.expiredSessionError }
                                        showTitle={ true }
                                        loggedOkCallBack={ this.logUser }
                                        expiredSessionCallbak={ this.manageExpiredSessions }
                                    />
                                </form>
                            </header>

                            <form id="healt_form">
                                <Pagination
                                    maxPagges={5}
                                    actualPage={this.state.actualPage}
                                    updateActualPageCallBack={this.updateActualPage}
                                    manageExpiredSessionsCallBack={this.manageExpiredSessions}
                                >
                                    <SinglePage
                                        show={this.state.actualPage === 1}
                                        pageNumber={1}
                                        isLast={false}
                                        validatePage={this.step1Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                    >
                                        <Contractor 
                                            people={this.state.contractor}
                                            updatePeopleCallback={this.updateContractor}
                                            user={this.state.user}
                                            updateUserCallBack={ this.updateUser }
                                            expiredSessionCallbak={ this.manageExpiredSessions }
                                            error={this.state.contractorError}
                                            isOnlyFisica={true}
                                            isOnlyGiuridica={false}
                                        />
                                        
                                    </SinglePage>

                                    <SinglePage
                                        show={this.state.actualPage === 2}
                                        pageNumber={2}
                                        isLast={false}
                                        validatePage={this.step2Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                    >
                                        <CommonsPolicyFields 
                                            rilevanza={ this.state.rilevanza }
                                            rilevanzaErrro={ this.state.rilevanzaError }
                                            updateRilevanza={ this.updateRilevanza }

                                            altriSinistri={this.state.altriSinistri}
                                            altriSinistriError={this.state.altriSinistriError}
                                            polizzaAttiva={this.state.polizzaAttiva}
                                            polizzaAttivaError={this.state.polizzaAttivaError}
                                            scadenzaPolizza={this.state.scadenzaPolizza}
                                            scadenzaPolizzaError={this.state.scadenzaPolizzaError}

                                            updateAltriSinistri={this.updateAltriSinistri}
                                            updatePloizzaAttiva={this.updatePloizzaAttiva}
                                            updateScadenzaPolizza={this.updateScadenzaPolizza}
                                        />

                                        <div className='col-12'>
                                            <Select
                                                id='tutelati' name='tutelati' key='soggetti'
                                                label='Chi vorresti tutelare?' 
                                                value={this.state.soggetti}
                                                options={this.state.tipo_tutelati}
                                                callback={this.updateSoggetti}
                                                error={this.state.soggettiError}
                                            />
                                        </div>
                                        
                                    </SinglePage>

                                    <SinglePage
                                        show={this.state.actualPage === 3}
                                        pageNumber={3}
                                        isLast={false}
                                        validatePage={this.step3Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                    >
                                        <div className='col-12'>
                                            <Select
                                                id='reddito' name='reddito' key='reddito'
                                                label='Reddito netto del nucleo familiare?' 
                                                value={this.state.reddito}
                                                options={this.state.tipo_reddito}
                                                callback={this.updateReddito}
                                                error={this.state.redditoError}
                                            />

                                            <MultipleCheckbox
                                                id='coperture'
                                                label='Quali sono le coperture per te più importanti per tutelare la salute?'
                                                value={this.state.coperture}
                                                options={this.state.tipo_tutelesalute}
                                                error={this.state.copertureError}
                                                callBack={this.updateCoperture}
                                                isMultiple={true}
                                            />
                                        </div>

                                    </SinglePage>

                                    <SinglePage
                                        show={this.state.actualPage === 4}
                                        pageNumber={4}
                                        isLast={false}
                                        validatePage={this.step4Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                    >
                                        <div className='col-12'>
                                            <SiNo 
                                                label='Una delle persone assicurate si è trovata o sta affrontando una delle seguenti "situazioni particolari"?'
                                                id='hasSituazioni'
                                                value={ getSiNoValue(this.state.hasSituazioni) }
                                                callback={this.updateHasSituazioni}
                                                error={this.state.hasSituazioniError}
                                            />

                                            { this.state.hasSituazioni &&
                                                <MultipleCheckbox
                                                    id='situazioni'
                                                    label='Indica quali'
                                                    value={this.state.situazioni}
                                                    options={this.state.tipo_situazioni}
                                                    error={this.state.situazioniError}
                                                    callBack={this.updateSituazioni}
                                                    isMultiple={true}
                                                />
                                            }
                                        </div>
                                    </SinglePage>

                                    <SinglePage
                                        show={this.state.actualPage === 5}
                                        pageNumber={5}
                                        isLast={true}
                                        validatePage={this.step5Validation}
                                        updateActualPageCallBack={this.updateActualPage}
                                        sendCallBack={this.sendData}
                                    >
                                        <div className='col-12'>
                                            <SiNo 
                                                label='Nello specifico, ha mai avuto o sta affrontando una delle patologie?'
                                                id='hasPatologie'
                                                value={ getSiNoValue(this.state.hasPatologie) }
                                                callback={this.updateHasPatologie}
                                                error={this.state.hasPatologieError}
                                            />

                                            { this.state.hasPatologie &&
                                                <MultipleCheckbox
                                                    id='patologie'
                                                    label='Indica quali'
                                                    value={this.state.patologie}
                                                    options={this.state.tipo_malattie}
                                                    error={this.state.patologieError}
                                                    callBack={this.updatePatologie}
                                                    isMultiple={true}
                                                />
                                            }
                                        </div>

                                        <NoMotorPrivacy 
                                            id='noMotorPrivacy'
                                            basePrivacy={this.state.noMotorPrivacy}
                                            isLogged={this.state.user !== undefined}
                                            callback={this.updateNoMotorPrivacy}
                                            error={this.state.noMotorPrivacyError}
                                        />
                                    </SinglePage>

                                </Pagination>
                            </form>

                        </div>
                    </div>

                    <ModalWaith isOpen={this.state.waith}/>

                    <ModalNotification
                        title='Si è verificato un problema'
                        isError={erroOccours}
                        isOpen={erroOccours}
                        callBackToggle={ () => this.setState ({globalError: undefined}) }
                    >
                        {this.state.globalError}
                    </ModalNotification>

                    <ModalFinalQuestion 
                        isOpen={this.state.finalQuestIsOpen}
                        quoteRequestId={this.state.quoteRequestId}
                        callBackToggle={this.closeFinalQuestion}
                        expiredSessionCallbak={this.manageExpiredSessions}
                    />
                </article>
            </>
        )
    }

    getInitialState() {
        return healtPageInitialState
    }

    getValidationError () : Promise<CompleteValidationError> {
        return Promise.all([
            this.step1Validation(),
            this.step2Validation(),
            this.step3Validation(),
            this.step4Validation(),
            this.step5Validation(),
        ]).then ((responses) => {
            let p: number | undefined = undefined
            let e: string | undefined  = undefined

            if (responses[0] !== undefined) {
                p = 1
                e = responses[0]
            }
            else if (responses[1] !== undefined) {
                p = 2
                e = responses[1]
            }
            else if (responses[2] !== undefined) {
                p = 3
                e = responses[2]
            }
            else if (responses[3] !== undefined) {
                p = 4
                e = responses[3]
            }
            else if (responses[4] !== undefined) {
                p = 5
                e = responses[4]
            }
            
            return {
                errorString: e,
                pageError: p
            }
        }).catch (() => {
            return {
                errorString: CONNECTION_ERROR,
                pageError: undefined
            }
        })
    }

    printError (errorString: string | undefined, waith: boolean = false, pageError: number | undefined = undefined) {
        let contractorErro = undefined
        let altriSinistriErro = undefined
        let polizzaAttivaErro = undefined
        let scadenzaPolizzaErro = undefined

        let soggettiErro = undefined
        let redditoErro = undefined
        let copertureErro = undefined
        let situazioniErro = undefined
        let patologieErro = undefined

        let noMotorPrivacyErro = undefined
        let profeErro = undefined
        let global = undefined

        const isLogged = this.state.user !== undefined

        const NOW = new Date()
        const DATE_START_FORMATTED = moment(NOW).format(DATE_FORMAT)

        if ( errorString === 'CONTRACTOR' ) {
            contractorErro = (isLogged)
                ?   'Selezionare almeno un contraente'
                :   'Alcuni valori del contraente non sono validi'
            global = contractorErro
        }
        else if ( errorString === 'SINISTRI' ) {
            altriSinistriErro = 'Indicare se ci sono stati altri sinistri'
            global = altriSinistriErro
        }
        else if ( errorString === 'POLIZZA' ) {
            polizzaAttivaErro = 'Indicare se esiste una polizza attiva'
            global = polizzaAttivaErro
        }
        else if ( errorString === 'SCADENZA_POLIZZA' ) {
            const DATE_END_FORMATTED = moment(NOW).add(1, 'months').format(DATE_FORMAT)

            scadenzaPolizzaErro = 'tra ' + DATE_START_FORMATTED + ' e ' + DATE_END_FORMATTED
            global = 'Inserire una data tra ' + DATE_START_FORMATTED + ' e ' + DATE_END_FORMATTED
        }
        else if ( errorString === 'PRIVACY' ) {
            noMotorPrivacyErro = 'Selezionare i campi obbligatori'
            global = noMotorPrivacyErro
        } 
        else if ( errorString === 'PROFESSIONE' ) {
            profeErro = 'Selezionare un valore per il campo "Professione"'
            global = profeErro
        }
        else if (errorString === 'TOKEN_EXPIRED') {
            global = 'Sessione scaduta, ti preghiamo di ri autenticarti'
        }

        else if ( errorString === 'SOGGETTI' ) {
            soggettiErro = 'Valore non valido / mancante'
            global = 'Indicare i soggetti da assicurare'
        }
        else if ( errorString === 'REDDITO' ) {
            redditoErro = 'Valore non valido / mancante'
            global = 'Indicare il reddito medio'
        }
        else if ( errorString === 'COPERTURE' ) {
            copertureErro = 'Valore non valido / mancante'
            global = 'Indicare le coperture assicurative'
        }
        else if ( errorString === 'SITUAZIONI' ) {
            situazioniErro = 'Valore non valido / mancante'
            global = 'Indicare le eventuali situazioni particolari'
        }
        else if ( errorString === 'PATOLOGIE' ) {
            patologieErro = 'Valore non valido / mancante'
            global = 'Indicare le eventuali patologie'
        }

        else {
            global = errorString
        }

        this.setState ({
            waith: waith,
            actualPage: pageError ?? this.state.actualPage,

            contractorError: contractorErro,
            altriSinistriError: altriSinistriErro,
            polizzaAttivaError: polizzaAttivaErro,
            scadenzaPolizzaError: scadenzaPolizzaErro,

            soggettiError: soggettiErro,
            redditoError: redditoErro,
            copertureError: copertureErro,
            situazioniError: situazioniErro,
            patologieError: patologieErro,
            
            noMotorPrivacyError: noMotorPrivacyErro,
            globalError: global,
        })
    }

    getSpecificDataForSubmit () {
        return {
            sinistriPrecedenti: this.state.altriSinistri ?? false,
            polizzaGiaAttiva: this.state.polizzaAttiva ?? false,
            dataScadenza: (this.state.polizzaAttiva === true) 
                ? (this.state.scadenzaPolizza ?? null)
                : null,

            rilevanza: this.getRilevanzaForSubmit(),

            soggetti: this.state.soggetti ?? null,
            reddito: this.state.reddito ?? null,
            coperture: this.state.coperture ?? null,
            situazioni: this.state.situazioni ?? null,
            patologie: this.state.patologie ?? null,
        }
    }
    
    saveStateAndRedux (newState : object) {
        this.setState(
            newState, () => {
                store.dispatch (
                    healthUpdate (this.state)
                )
            }
        )
    }

    // -- solo del preventivatore

    private updateTipo_tutelati (val: any) {
        this.setState({
            tipo_tutelati: val
        })
    }
    private updateTipo_tutelesalute (val: any) {
        this.setState({
            tipo_tutelesalute: val
        })
    }
    private updateTipo_reddito (val: any) {
        this.setState({
            tipo_reddito: val
        })
    }
    private updateTipo_situazioni (val: any) {
        let next = val

        if (next.Nessuna) {
            delete next.Nessuna
        }

        this.setState({
            tipo_situazioni: next
        })
    }
    private updateTipo_malattie (val: any) {
        let next = val

        if (next.Nessuna) {
            delete next.Nessuna
        }

        this.setState({
            tipo_malattie: next
        })
    }

    private updateSoggetti (val: string | undefined) {
        this.saveStateAndRedux({
            soggetti: val,
            soggettiError: undefined
        })
    }
    private updateReddito (val: string | undefined) {
        this.saveStateAndRedux({
            reddito: val,
            redditoError: undefined
        })
    }
    private updateCoperture (val: string | undefined, add: boolean) {
        let next = this.state.coperture

        if ( val ) {
            if (add) {
                if (!next?.includes(val + '|')) {
                    next = (next ?? '') + val + '|'
                }
            }
            else {
                next = (next ?? '').replace( val + '|', '')
            }
        }

        if (next === '') {
            next = undefined
        }

        this.saveStateAndRedux({
            coperture: next,
            copertureError: undefined
        })
    }
    private updateSituazioni (val: string | undefined, add: boolean) {
        let next = this.state.situazioni

        if ( val ) {
            if (add) {
                if (!next?.includes(val + '|')) {
                    next = (next ?? '') + val + '|'
                }
            }
            else {
                next = (next ?? '').replace( val + '|', '')
            }
        }

        this.saveStateAndRedux({
            situazioni: next,
            situazioniError: undefined
        })
    }
    private updatePatologie (val: string | undefined, add: boolean) {
        let next = this.state.patologie

        if ( val ) {
            if (add) {
                if (!next?.includes(val + '|')) {
                    next = (next ?? '') + val + '|'
                }
            }
            else {
                next = (next ?? '').replace( val + '|', '')
            }
        }

        this.saveStateAndRedux({
            patologie: next,
            patologieError: undefined
        })
    }

    private updateHasSituazioni (val: SiNoType) {
        const has = getBoolean(val)

        this.saveStateAndRedux({
            hasSituazioni: has,
            situazioni: (has) ? undefined : 'Nessuna|',
            situazioniError: undefined
        })
    }
    private updateHasPatologie (val: SiNoType) {
        const has = getBoolean(val)

        this.saveStateAndRedux({
            hasPatologie: has,
            patologie:  (has) ? undefined : 'Nessuna|',
            patologieError: undefined
        })
    }

    private async step2Validation() {
        return HealthValidation.page2Validation(
            this.state.altriSinistri,
            this.state.polizzaAttiva,
            this.state.scadenzaPolizza,
            this.state.soggetti,
            this.printError,
            this.manageExpiredSessions
        )
    }

    private async step3Validation() {
        return HealthValidation.page3Validation(
            this.state.reddito,
            this.state.coperture,
            this.printError,
            this.manageExpiredSessions
        )
    }

    private async step4Validation() {
        return HealthValidation.page4Validation(
            this.state.situazioni,
            this.printError,
            this.manageExpiredSessions
        )
    }

    private async step5Validation() {
        return HealthValidation.page5Validation(
            this.state.patologie,
            getPrivacyForSubmit( this.state.contractor, this.state.noMotorPrivacy, this.state.user),
            this.state.user,
            this.printError,
            this.manageExpiredSessions
        )
    }
}

const mapState = (state: any) => {
  return {
    contractor: state.contractor,
    altriSinistri: state.altriSinistri,
    polizzaAttiva: state.polizzaAttiva,
    scadenzaPolizza: state.scadenzaPolizza,
    rilevanza: state.rilevanza,

    soggetti: state.soggetti,
    reddito: state.reddito,
    coperture: state.coperture,
    situazioni: state.situazioni,
    patologie: state.patologie,

    hasSituazioni: state.hasSituazioni,
    hasPatologie: state.hasPatologie,

    actualPage: state.actualPage,

    noMotorPrivacy: state.noMotorPrivacy,
    user: state.user
  }
}

export default connect(mapState) (HealthPage)